import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { StyledBox, StyledTooltip, NewStyledIconButton } from 'styles/common';

import theme from 'constants/theme';

export const ToggleSwitch = ({
  iconsList,
  onIconClick,
  selectedId,
  height = null,
  display = null,
  bgcolor = theme.palette.background.lightGrey2,
}) => (
  <StyledBox
    height={height}
    bgcolor={bgcolor}
    borderRadius="4px"
    padding="0.25rem"
    style={{ display: display ?? 'block' }}
  >
    {iconsList.map(({ id, icon, disabled, tooltipText = '' }) => (
      <StyledTooltip key={`switch-${id}`} title={tooltipText}>
        <ToggleButton
          onClick={() => {
            if (!disabled) onIconClick(id);
          }}
          selected={id === selectedId}
          size="smallest"
          disabled={disabled}
          component="div"
        >
          {icon}
        </ToggleButton>
      </StyledTooltip>
    ))}
  </StyledBox>
);
ToggleSwitch.propTypes = {
  iconsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
    })
  ).isRequired,
  onIconClick: PropTypes.func.isRequired,
  selectedId: PropTypes.string,
  height: PropTypes.string,
};
const ToggleButton = styled(NewStyledIconButton)`
  padding: 0.375rem 1rem;
  border-radius: 4px;
  color: ${(props) => props.theme.palette.text.secondary} !important;

  ${(props) =>
    props.selected &&
    css`
      background-color: white;
      color: ${props.theme.palette.primary.main} !important;

      svg {
        fill: ${props.theme.palette.primary.main} !important;
      }
    `};

  ${(props) =>
    props.disabled &&
    css`
      svg {
        fill: ${props.theme.palette.icons.grey} !important;
      }
    `};

  pointer-events: auto !important;
`;
